import axios from 'axios';
import request, { MethodEnum } from '@/utils/fetch';

// https://bbs.dji.com/plugin.php?id=dsu_paulsign:sign&operation=qiandao&infloat=1&sign_as=1&pc_ajax=1
// 签到
export const checkIn = (formhash:string) => {
  // 移动端的测试一下如果不通过，可以尝试修改mobile=1
  const url = `/plugin.php?id=dsu_paulsign:sign&operation=qiandao&infloat=1&sign_as=1&pc_ajax=1&mobile=0`;
  const data = {
    formhash,
    qdmode: 4,
    todaysay: '',
    fastreply: 0,
  }
  return axios({
    url,
    data,
    method: MethodEnum.POST,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  }).then((data) => data?.data).catch((e) => Promise.reject(e?.response?.data?.error));
};

// 测试
// export const testSkypixel = () => {
//   const url = 'https://cn-test-sp.skypixel.com/api/v2/tests/show-all-headers';
//   return axios({
//     url,
//     method: MethodEnum.GET,
//     headers: { "Content-Type": "application/json" },
//   }).then((data) => data?.data).catch((e) => Promise.reject(e?.response?.data?.error));
// };

export interface ICheckInResult {
  days: number; // 签到天数
  lasted: number; // 连续签到天数
  mdays: number; // 本月签到天数
  signed: boolean; // 今天是否签到过，true已签到，false未签到
}

export interface ICheckInResultRes {
  item: ICheckInResult;
}

export const getCheckInResult = () => {
  return request({
    url: '/home/paulsigns/user',
    params: {t: new Date().valueOf()},
  }).then((data: ICheckInResultRes) => data?.item).catch((e)=>Promise.reject(e));
}
